import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

export default function init() {
  // eslint-disable-next-line no-unused-vars
  const lightbox = GLightbox({
    selector: '.js-lightbox',
    loop: false,
    videosWidth: 1920,
    videosHeight: 1080,
  });
}
